import { getMarkerIcon, getMarkerIconSolid } from './getMarkerIcon';

const getMarker = (args) => {
  const { item, activeMarker, latLngGroups } = args;
  const { name, latitude, longitude, company, communityId } = item;
  const latLng = new google.maps.LatLng(latitude, longitude);

  const marker = new google.maps.Marker({
    position: latLng,
    name: name,
    communityId: communityId,
    company: company
  });

  return marker;
};

const singleMarkerDecorator = args => {
  const { item, activeMarker, marker } = args;
  const { name, company } = item;
  marker.setTitle(name);
  marker.setIcon(getMarkerIcon(company, activeMarker, name));
  marker.type = 'standard';
};

const multipleMarkerDecorator = args => {
  const { item, activeMarker, latLngGroups, marker } = args;
  const { name, latitude, longitude, company } = item;
  const latLngKey = `${latitude},${longitude}`;
  marker.setLabel({ text: `${latLngGroups[latLngKey].length}`, color: '#fff' });
  marker.setTitle(`${latLngGroups[latLngKey].length} Communities`);
  marker.setIcon(getMarkerIconSolid(company, activeMarker, name));
  marker.type = 'solid';
};

const stripMarkerDecoration = marker => {
  marker.setLabel(null);
  marker.setTitle(null);
  marker.setIcon(null);
  marker.type = null;
};

export { getMarker, stripMarkerDecoration, singleMarkerDecorator, multipleMarkerDecorator };